import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { DashboardModule } from '../dashboard/dashboard.module';
import { TabsPage } from './pages/tabs.page';
import { TabsRoutingModule } from './tabs-routing.module';

@NgModule({
  imports: [CommonModule, IonicModule, TabsRoutingModule, DashboardModule],
  declarations: [TabsPage],
  exports: [TabsPage],
})
export class TabsModule {}
